import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NgxSpinnerService} from 'ngx-spinner';
import {AerovaleDetalle} from '@shared/models/despacho/AerovaleDetalle';
import {ErrorModel} from '@shared/models/ErrorModel';
import {Holdeo} from '@shared/models/facturacion/Holdeo';
import {MessageService} from '@shell/message.service';
import {ComprobanteService} from '../../comprobante.service';
import {NuevoHoldeoComponent} from '../nuevo-holdeo/nuevo-holdeo.component';
import {AerovalesService} from '@despacho/aerovales.service';
import {AerovaleDetalleComponent} from '@despacho/aerovale-detalle/aerovale-detalle.component';
import {TipoHoldeo} from '@shared/enums/TipoHoldeo';

@Component({
  selector: 'app-holdeo-aerovales',
  templateUrl: './holdeo-aerovales.component.html',
  styleUrls: ['./holdeo-aerovales.component.css']
})
export class HoldeoAerovalesComponent implements OnInit {
  @Output() volver = new EventEmitter();

  obteniendo: boolean = false;
  cuentasHoldeadas: Holdeo[] = [];
  desactivandoCuenta: boolean = false;
  obteniendoAerovale: boolean = false;
  aerovaleDetalle: AerovaleDetalle;
  aerovaleSeleccionado: number;
  cuentaSeleccionada: number;

  constructor(
    private modal: NgbModal,
    private spinner: NgxSpinnerService,
    private comprobantesService: ComprobanteService,
    private aerovaleService: AerovalesService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.getHoldeoCuenta();
  }

  getHoldeoCuenta() {
    this.spinner.show('spinnerLista');
    this.obteniendo = true;
    this.comprobantesService.getHoldeo(4, TipoHoldeo.Aerovale)
      .subscribe(result => {
        this.cuentasHoldeadas = result;
        this.spinner.hide('spinnerLista');
        this.obteniendo = false;
      });
  }

  nuevoHoldeoAerovle() {
    const modalRef = this.modal.open(NuevoHoldeoComponent, { centered: true, backdrop: 'static' });
    modalRef.componentInstance.tipo = 2;
    modalRef.result.then(result => {
      result == true ? this.ngOnInit() : null;
    })
  }

  quitarCuentas(i: number){
    this.desactivandoCuenta = true;
    this.cuentaSeleccionada = i;
    this.cuentasHoldeadas[i].activo = !this.cuentasHoldeadas[i].activo;
    this.comprobantesService.putHoldeo(this.cuentasHoldeadas[i])
      .subscribe(result => {
        this.messageService.showSuccessMessage(`El holdeo del aerovale fue ${result.activo ? 'activado' : 'desactivado'} con éxito`);
        this.getHoldeoCuenta();
        this.desactivandoCuenta = false;
        this.cuentaSeleccionada = null;
      }, () => {
        this.messageService.showErrorMessage('Hubo un error al actualizar el estado del aerovale');
        this.desactivandoCuenta = false;
        this.cuentaSeleccionada = null;
      });
  }

  obtenerAerovale(id:string, i:number) {
    this.aerovaleDetalle = null;
    this.aerovaleSeleccionado = i;
    this.obteniendoAerovale = true;
    this.aerovaleService.getAerovalePorIdyTipo(id)
      .subscribe(result => {
        this.aerovaleDetalle = result;
        this.aerovaleSeleccionado = null;
        this.obteniendoAerovale = false;
        if(this.aerovaleDetalle) {
          this.mostrarAerovale();
        }}, (err: ErrorModel) => {
          this.messageService.showErrorMessage('Hubo un error al obtener el Aerovale' + err.description);
          this.aerovaleSeleccionado = null;
          this.obteniendoAerovale = false;
        });
  }

  mostrarAerovale() {
    const modalRef = this.modal.open(AerovaleDetalleComponent, { size: "lg", centered: true});
    modalRef.componentInstance.aerovaleDetalle = this.aerovaleDetalle;
  }

  goBack(){
    this.volver.emit(true);
  }
}
